module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Payment ' + (_vm.index + 1) + ' Date',
      "no-flex-margin": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "date",
      "required": ""
    },
    on: {
      "input": _vm.updateInterest
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidDate() || _vm.$error('date')
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY, be after the deceased's date of death\n            (" + _vm._s(_vm.deceasedDod) + ") and be before the interest calculation date\n        ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Amount",
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "max": _vm.remainingTotal,
      "min": "1",
      "name": "value",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateInterest],
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            The amount must be at least £1.00 and less than the total past heads of loss \n            remaining total " + _vm._s(_vm.currencyFormat(_vm.remainingTotal)) + "\n        ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisPayment
    }
  }, [_vm._v("Delete This Payment")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75387b3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/estate/steps/interim/Payment.vue
// module id = 1746
// module chunks = 0